import { render, staticRenderFns } from "./BaseRadioButtonGroup.vue?vue&type=template&id=b06954b4&scoped=true"
import script from "./BaseRadioButtonGroup.vue?vue&type=script&lang=ts"
export * from "./BaseRadioButtonGroup.vue?vue&type=script&lang=ts"
import style0 from "./BaseRadioButtonGroup.vue?vue&type=style&index=0&id=b06954b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06954b4",
  null
  
)

export default component.exports